const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolve an angel image URL:
 *   - External http(s) URLs are returned unchanged.
 *   - Relative paths get the backend origin prefixed and an optional
 *     ?v=<imageVersion> cache-buster appended.
 *
 * Images live in /app/frontend/public/images/angels/ and are served by the
 * frontend's static server at the same origin as the API in this preview.
 */
export function withImageVersion(url, version) {
    if (!url) return url;
    if (url.startsWith("http")) return url;
    const base = `${BACKEND_URL}${url}`;
    if (!version) return base;
    const sep = base.includes("?") ? "&" : "?";
    return `${base}${sep}v=${version}`;
}
